import { createIcon } from '@chakra-ui/react';

export const CarretRightIcon = createIcon({
  displayName: 'CarretRightIcon',
  viewBox: '0 0 7 12',
  path: [
    <path
      key="1"
      d="M1 1.5L5 6L1 10.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      fill="transparent"
    />
  ]
});
